/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
export function jfTrashPin() {
    return {
        scope: {
            treeBrowser: '='
        },
        restrict: 'E',
        controller: JFTrashPinController,
        controllerAs: 'jfTrashPin',
        bindToController: true,
        template: `<i class="icon icon-pin trash-pin"
                      ng-class="{'icon-pin': !jfTrashPin.treeBrowser.isTrashPinned(), 'icon-unpin': jfTrashPin.treeBrowser.isTrashPinned()}"
                      ng-style="{left: jfTrashPin.getLeftPosition()}" 
                      ng-click="jfTrashPin.treeBrowser.toggleTrashPin($event); jfTrashPin.updateTooltipText()"  
                      jf-tooltip="{{jfTrashPin.tooltipText}}"></i>`
    }
}


class JFTrashPinController {
    constructor($element) {
        this.$element = $element;
    }

    $onInit() {
        this.updateTooltipText();
    }

    updateTooltipText() {
        this.tooltipText = !this.treeBrowser.isTrashPinned() ? 'Pin Trash Can' : 'Unpin Trash Can';
    }

    getLeftPosition() {
        let trashPin = $(this.$element).find('.trash-pin');
        let hScroll = trashPin.parents('.h-scroll-wrapper');
        return hScroll.scrollLeft() + hScroll.parent().width() - 50 + 'px';
    }

}



// WEBPACK FOOTER //
// ./states/artifacts/jf_tree_browser/jf_trash_pin.js